/**
 * TemplatesTab Component
 * Settings page tab for managing project templates
 * Phase 7 Batch 7.3 - Proposal Frontend
 */
import { useNavigate } from 'react-router-dom';
import { TemplatesList } from '@/components/TemplatesList';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

export function TemplatesTab() {
  const navigate = useNavigate();

  const handleCreateTemplate = () => {
    navigate('/projects/new?isTemplate=true');
  };

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <h2 className="text-2xl font-bold tracking-tight">Project Templates</h2>
          <p className="text-muted-foreground">
            Manage reusable project templates for quickly starting new proposals.
          </p>
        </div>
        <Button onClick={handleCreateTemplate}>
          <Plus className="h-4 w-4 mr-2 lucide-plus" />
          Create New Template
        </Button>
      </div>

      {/* Help Text */}
      <div className="rounded-lg border bg-muted/50 p-4">
        <p className="text-sm text-muted-foreground">
          Templates help you quickly start new proposals with pre-configured scopes and items.
          Create a template by setting up a project with the scopes and billable items you commonly use,
          then mark it as a template when saving.
        </p>
      </div>

      {/* Templates List */}
      <TemplatesList />
    </div>
  );
}
